import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6f50d7b8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "../assets/css/detail.scss?vue&type=style&index=0&id=6f50d7b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50d7b8",
  null
  
)

export default component.exports